export const loaderTypes = {
  LOAD_THE_LOADER: "loader/LOAD_THE_LOADER",
  KILL_THE_LOADER: "loader/KILL_THE_LOADER",
};
